<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-card style="width: 700px">
            <v-card-title primary-title>
              <div>
                <div class="headline pl-2 pa-1">
                  {{ priceRule.pull_down_cluster_title }}
                </div>
              </div>
            </v-card-title>
            <v-flex>
              <v-form ref="form" v-model="form" class="pa-4 pt-6">
                <label style="font-size: large"
                  >{{ $t("settings.editPriceRules.minPriceFor", { cluster: priceRule.pull_down_cluster_title }) }}</label
                >
                <v-text-field
                  
                  v-model="priceRule.minPrice"
                  :label="$t('settings.editPriceRules.minPriceValue')"
                  type="text"
                  style="margin-top: 15px"
                ></v-text-field>

                <label style="font-size: large"
                  >{{ $t("settings.editPriceRules.maxPriceFor", { cluster: priceRule.pull_down_cluster_title }) }}</label
                >
                <v-text-field
                  
                  v-model="priceRule.maxPrice"
                  :label="$t('settings.editPriceRules.maxPriceValue')"
                  type="text"
                  style="margin-top: 15px"
                ></v-text-field>

                <label style="font-size: large"
                  >{{ $t("settings.editPriceRules.eventMinPriceFor", { cluster: priceRule.pull_down_cluster_title }) }}</label
                >
                <v-text-field
                  
                  v-model="priceRule.eventMinPrice"
                  :label="$t('settings.editPriceRules.eventMinPriceValue')"
                  type="text"
                  style="margin-top: 15px"
                ></v-text-field>

                <label style="font-size: large"
                  >{{ $t("settings.editPriceRules.eventMaxPriceFor", { cluster: priceRule.pull_down_cluster_title }) }}</label
                >
                <v-text-field
                  
                  v-model="priceRule.eventMaxPrice"
                  :label="$t('settings.editPriceRules.maxPriceValue')"
                  type="text"
                  style="margin-top: 15px"
                ></v-text-field>


                <label style="font-size: large"
                  >{{ $t("settings.editPriceRules.minTimeFor", { cluster: priceRule.pull_down_cluster_title }) }}</label
                >
                <v-text-field
                  
                  v-model="priceRule.minTime"
                  :label="$t('settings.editPriceRules.minTimeValue')"
                  type="text"
                  style="margin-top: 15px"
                ></v-text-field>

                <v-btn :loading="loading" block @click="save" color="secondary"
                  >{{ $t("settings.editPriceRules.save") }}
                </v-btn>
              </v-form>
            </v-flex>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "Edit_Price_Rules",
  title() {
    return this.$t("settings.editPriceRules.title");
  },
  components: {},

  data() {
    return {
      loading: false,
      form: false,
      priceRule: {
        pull_down_cluster_title: "",
        pull_down_location_cluster_id: 0,
        minPrice: 0.0,
        maxPrice: 0.0,
        minTime: 0,
      },
    };
  },
  created() {
    this.axios.get(`priceRule/${this.$route.params.id}`).then(({ data }) => {
      this.priceRule.pull_down_cluster_title =
        data.data.pull_down_location_cluster_title;
      this.priceRule.pull_down_location_cluster_id =
        data.data.pull_down_location_cluster_id;
      this.priceRule.minPrice = data.data.min_price;
      this.priceRule.maxPrice = data.data.max_price;
      this.priceRule.eventMinPrice = data.data.event_min_price;
      this.priceRule.eventMaxPrice = data.data.event_max_price;
      this.priceRule.minTime = data.data.min_time;
    });
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) {
        window.getApp.$emit(
          "SHOW_TOAST",
          this.$t("settings.editPriceRules.invalidNumber"),
          "red"
        );
        return;
      }
      this.loading = true;

      this.axios
        .put(`priceRule/${this.$route.params.id}`, {
          pull_down_location_cluster_id:
            this.priceRule.pull_down_location_cluster_id,
          min_price: this.priceRule.minPrice,
          max_price: this.priceRule.maxPrice,
          event_min_price: this.priceRule.eventMinPrice,
          event_max_price: this.priceRule.eventMaxPrice,
          min_time: this.priceRule.minTime,
        })
        .then(() => {
          window.getApp.$emit("SHOW_TOAST", this.$t("settings.editPriceRules.saved"));
          this.$router.push(`/priceRules`);
        })
        .catch(({ response }) => {
          window.getApp.$emit(
            "SHOW_TOAST",
            response.data.message || this.$t("settings.editPriceRules.saveFailed"),
            "red"
          );
          console.log(response);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
